<kodit-dropdown
  (optionChanged)="handleOnItemChange($event)"
  [formCtrl]="formCtrl!"
  [options]="items"
  ctrlTooltip="Izaberite tip dokumenta"
  ctrlTooltipPosition="top"
  [ctrlDisabled]="shouldDisable"
></kodit-dropdown>
